import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

type UseScrollToAnchorProps = {
  anchor: () => JSX.Element;
  triggerScrollToAnchor: () => void;
};

const SCROLL_PADDING = 16;

export default function useScrollToAnchor({
  offset = 0,
}): UseScrollToAnchorProps {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
  const triggerScrollToAnchor = useCallback(() => {
    setShouldScrollToTop(true);
  }, []);
  const anchor = useCallback(() => <div ref={containerRef} />, []);

  const scrollToAnchor = useCallback(() => {
    const totalOffset = offset > 0 ? offset + SCROLL_PADDING : offset;
    containerRef.current.style.scrollMarginTop = `${totalOffset}px`;
    containerRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [offset]);

  useLayoutEffect(() => {
    if (shouldScrollToTop) {
      setShouldScrollToTop(false);
      if (containerRef.current) {
        scrollToAnchor();
      }
    }
  }, [shouldScrollToTop, setShouldScrollToTop, scrollToAnchor]);
  return { anchor, triggerScrollToAnchor };
}
